<div class="not-found">
  {{ 'global.error.pageNotFound' | translate }}
</div>

<div class="redirect-container" routerLink="/summary">
  {{ 'global.redirectHome' | translate }}
</div>